
import React from 'react';

export const LockClosedIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    lock
  </span>
);